<template>
  <main :aria-label="isEditMode ? $t('hashtag.edit') : $t('hashtag.add')" class="hashtag-au-page">
    <CompanyBreadcrumb :aria-label="isEditMode ? $t('hashtag.edit') : $t('hashtag.add')"
                       :home-aria-label="$t('general.home')"
                       :items="breadcrumbItems"
    />

    <template v-if="errorMessages && errorMessages.length">
      <div v-for="(error, index) in errorMessages"
           :key="index"
           class="card hashtag-alert-card">
        <div class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p>
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </div>
    </template>

    <div v-if="successMessage" class="card hashtag-alert-card">
      <div class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p>
          <i class="uil-check"></i> {{ successMessage }}
        </p>
      </div>
    </div>

    <div class="card hashtag-au-card" v-if="is_loading">
      <default-loading></default-loading>
    </div>
    <template v-else>
      <div class="section-header mb-lg-2 border-0 uk-flex-middle hashtag-page-header">
        <div class="section-header-left">
          <h2 class="hashtag-page-title">
            <span><i class="uil-gift"></i> {{ isEditMode ? $t("hashtag.edit") : $t("hashtag.add") }}</span>
          </h2>
        </div>
      </div>

      <div class="card hashtag-au-card">
        <div class="card-body hashtag-form-body">
          <form @submit.prevent="saveForm">
            <div class="hashtag-form-group">
              <label class="hashtag-form-label" for="name">
                {{ $t("hashtag.name") }} <span class="required">*</span>
              </label>
              <div class="hashtag-form-input">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  name="name"
                  :placeholder="$t('hashtag.enter_name')"
                  required
                  v-model="form.name"
                />
              </div>
            </div>

            <div class="hashtag-form-actions">
              <router-link
                class="btn btn-default hashtag-back-btn"
                :to="{ name: 'company.hashtags.list' }"
              >
                {{ $t("general.back") }}
              </router-link>
              <button
                class="btn btn-default hashtag-save-btn"
                type="submit"
              >
                <i class="icon-feather-arrow-right"></i>
                {{ $t("general.save") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </template>
  </main>
</template>

<script>
import store from "@/core/services";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import CompanyBreadcrumb from "@/view/company/components/breadcrumb/CompanyBreadcrumb.vue";
import hashtag_module, {
  BASE_URL,
  MODULE_NAME,
  ERROR,
  ITEM,
  CREATE_ITEM,
  GET_ITEM,
  UPDATE_ITEM,
} from "@/core/services/store/hashtag.module";
export default {
  name: "HashtagAddUpdate",
  components: { DefaultLoading, CompanyBreadcrumb },
  data() {
    return {
      is_loading: false,
      form: {
        name: "",
      },
      successMessage: null,
      errorMessages: [],
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(MODULE_NAME, hashtag_module);
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    breadcrumbItems() {
      return [
        { name: this.$t("general.tags") },
        { name: this.isEditMode ? this.$t("hashtag.edit") : this.$t("hashtag.add") },
      ];
    },
    item: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEM];
      },
      set(value) {},
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {},
    },
  },
  methods: {
    getItem() {
      this.is_loading = true;
      store
        .dispatch(MODULE_NAME + "/" + GET_ITEM, {
          url: BASE_URL + "/" + this.$route.params.id,
        })
        .then(() => {
          this.form.name = this.item.name;
          this.is_loading = false;
        });
    },
    saveForm() {
      let form = this.form;
      let formData = new FormData();
      this.errorMessages = [];
      this.is_loading = true;
      if (form.name.length === 0) {
        this.errorMessages.push(
          this.$t("validation.required_field").replace(":NAME", this.$t("hashtag.name"))
        );
        this.is_loading = false;
        return false;
      }

      formData.append("name", form.name);

      if (this.isEditMode) {
        store
          .dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
            url: BASE_URL + "/" + this.$route.params.id + "/update",
            contents: formData,
            returnType: "stateless",
            acceptPromise: true,
          })
          .then(() => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_updated");
              this.$router.push({ name: "company.hashtags.list" });
            } else this.errorMessages.push(this.error);
            this.is_loading = false;
          });
      } else {
        store
          .dispatch(MODULE_NAME + "/" + CREATE_ITEM, {
            url: BASE_URL,
            contents: formData,
          })
          .then(() => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_created");
              this.$router.push({ name: "company.hashtags.list" });
            } else this.errorMessages.push(this.error);
            this.is_loading = false;
          });
      }
    },
    resetMessages() {
      this.errorMessages = [];
      this.successMessage = null;
    },
  },
  mounted() {
    if (this.isEditMode) {
      this.getItem();
    }
  },
  watch: {
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>

<style scoped>
.hashtag-au-page {
  --hashtag-primary: var(--primaryColor, #3e416d);
  --hashtag-text: #1e293b;
  --hashtag-muted: #64748b;
  --hashtag-border: #e2e8f0;
  min-width: 0;
}

.hashtag-alert-card {
  margin-bottom: 16px;
  overflow: hidden;
  border: 1px solid var(--hashtag-border);
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.hashtag-au-page .uk-alert {
  margin: 0;
}

.hashtag-au-page .uk-alert p {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
}

.hashtag-au-page .uk-alert-danger p {
  color: #dc3545;
}

.hashtag-au-page .uk-alert-success p {
  color: #28a745;
}

.hashtag-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.hashtag-page-title {
  margin: 0;
  color: var(--hashtag-text);
  font-size: 19px;
  font-weight: 600;
  line-height: 1.3;
}

.hashtag-au-card {
  overflow: hidden;
  margin-top: 0;
  border: 1px solid var(--hashtag-border);
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.hashtag-form-body {
  padding: 24px;
}

.hashtag-form-group {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.hashtag-form-label {
  flex: 0 0 auto;
  width: 160px;
  padding-top: 8px;
  color: var(--hashtag-text);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.hashtag-form-label .required {
  color: #dc3545;
}

.hashtag-form-input {
  flex: 1 1 auto;
  min-width: 0;
}

.hashtag-form-input .form-control {
  box-sizing: border-box;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  color: var(--hashtag-text);
  font-size: 15px;
  line-height: 1.5;
}

.hashtag-form-input .form-control:focus {
  border-color: var(--hashtag-primary);
  box-shadow: 0 0 0 3px rgba(62, 65, 109, 0.16);
  outline: none;
}

.hashtag-form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--hashtag-border);
}

.hashtag-back-btn {
  padding: 10px 17px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.hashtag-save-btn {
  padding: 10px 17px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.hashtag-back-btn:active,
.hashtag-save-btn:active {
  transform: scale(0.98);
  opacity: 0.85;
}

.hashtag-back-btn:disabled,
.hashtag-save-btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

@media (max-width: 959px) {
  .hashtag-page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .hashtag-page-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.4;
  }

  .hashtag-au-page .uk-alert p {
    font-size: 16px;
  }

  .hashtag-form-input .form-control {
    min-height: 48px;
    height: 48px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.4;
  }

  .hashtag-back-btn {
    min-height: 44px;
    padding: 12px 24px;
    font-size: 16px;
    line-height: 1.4;
  }

  .hashtag-save-btn {
    min-height: 48px;
    padding: 12px 24px;
    font-size: 16px;
    line-height: 1.4;
  }
}

@media (max-width: 767px) {
  .hashtag-au-page {
    margin: 0;
    padding: 0 0 24px;
  }

  .hashtag-au-card {
    border-radius: 14px;
  }

  .hashtag-form-body {
    padding: 16px;
  }

  .hashtag-form-group {
    flex-direction: column;
    gap: 8px;
  }

  .hashtag-form-label {
    width: 100%;
    padding-top: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
  }

  .hashtag-form-input {
    width: 100%;
  }

  .hashtag-form-actions {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .hashtag-back-btn {
    width: 100%;
    margin: 0;
    text-align: center;
  }

  .hashtag-save-btn {
    width: 100%;
    margin: 0;
    text-align: center;
  }
}

@media (hover: hover) and (pointer: fine) {
  .hashtag-back-btn:hover,
  .hashtag-save-btn:hover {
    opacity: 0.92;
    cursor: pointer;
  }
}

@media (hover: none) {
  .hashtag-au-page ::v-deep .btn-hover:hover {
    background-color: transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hashtag-back-btn:active,
  .hashtag-save-btn:active {
    transform: none;
  }
}
</style>
